import FoodDistributionPanel from './FoodDistributionPanel';

export default FoodDistributionPanel;
